import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const MontoFormGroup = ({ iError, iTouched, fIsSubmitting, index, handleBlur, values, actualizarFilaHandler, flagUltimo }) => {
  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(flagUltimo ? 'boton-guardar-cuotas' : `input-plazoDias-cuota-${index + 1}`, e)
    },
    [index, flagUltimo]
  )

  const innerHandleBlur = React.useCallback(
    e => {
      handleBlur(e)
      actualizarFilaHandler({ index: index, rowData: values })
    },
    [handleBlur, index, values, actualizarFilaHandler]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='monto'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id={`input-monto-cuota-${index}`}
              onBlur={innerHandleBlur}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoFormGroup)
